import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { newRochelleConfig } from "./data";

export default function NewRochellePage() {
  return <CityPageTemplate config={newRochelleConfig} />;
}